// extracted by mini-css-extract-plugin
module.exports = {"cart-page":"cart_cart-page__Iyg-X","cart-flex-wrapper":"cart_cart-flex-wrapper__1TnaA","cart-product-list":"cart_cart-product-list__CsPI1"};